import Arbeitsplatz from '@/types/Arbeitsplatz';

export default class Impfstelle {
    /** PK: Impfstelle | erforderlich */
    public impfstelle_id: number | null = null;
    /**  | max. 100 Zeichen | erforderlich */
    public bezeichnung: string | null = null;
    /**  | max. 20 Zeichen */
    public abkuerzung: string | null = null;
    /** gvOuID ist Primärschlüssel für Organisationseinheit | max. 50 Zeichen */
    public gv_ou_id: string | null = null;
    /**  | max. 100 Zeichen */
    public adresszeile1: string | null = null;
    /**  | max. 100 Zeichen */
    public adresszeile2: string | null = null;
    /**  | max. 100 Zeichen */
    public adresszeile3: string | null = null;
    /**  | max. 100 Zeichen */
    public adresszeile4: string | null = null;
    /**  | max. 100 Zeichen */
    public infozeile1: string | null = null;
    /**  | max. 100 Zeichen */
    public infozeile2: string | null = null;
    /**  | max. 100 Zeichen */
    public infozeile3: string | null = null;
    /**  | max. 100 Zeichen */
    public infozeile4: string | null = null;
    /**  | max. 50 Zeichen */
    public oid: string | null = null;
    /**  | max. 100 Zeichen */
    public oid_name: string | null = null;
    /**  | max. 100 Zeichen */
    public oid_strasse: string | null = null;
    /**  | max. 10 Zeichen */
    public oid_plz: string | null = null;
    /**  | max. 100 Zeichen */
    public oid_ort: string | null = null;
    /**  | max. 4 Zeichen */
    public a_card_pin: string | null = null;
    /** Ausstellungsort der Rechnung | max. 100 Zeichen */
    public ort: string | null = null;
    /**  */
    public jahr: number | null = null;
    /**  */
    public belegnr: number | null = null;
    /** Kassastand zu Beginn eines Tages */
    public anfangssaldo: number | null = null;
    /** FK: Person Verweis auf Tab. Personen, verantwortliche Person (Impfstellenleitung) */
    public person_id_verantw: number | null = null;
    /**  | max. 100 Zeichen */
    public cardreader_id_arzt: string | null = null;
    /** Sortierreihenfolge in Listenanzeige */
    public ordernumber: number | null = null;
    /** Impfstelle in Liste anzeigen j/n | max. 1 Zeichen */
    public gueltig: string | null = 'j';
    /**  */
    public zeitstempel: string | null = null;
    /** | Zahlungserrinerung ab Datum **/
    public zahlungserinnerungen_ab: string | null = null;
    /**  | max. 3 Zeichen **/
    public zahlungsziel_tage: number | null = null;
    /** | max. Zeichen **/
    public zahlungserinnerungstext: string | null = null;
    /** | max. Zeichen **/
    public termine_email_buchung: string | null = null;
    /** | max. Zeichen **/
    public termine_email_buchung_fehler: string | null = null;
    /** | max. Zeichen **/
    public termine_anmeldung_text: string | null = null;

    public arbeitsplaetze: Arbeitsplatz[] | null = null;
}
